import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { PageHeader, Menu, Dropdown, Button, Tag, Space, Col, Row  } from 'antd';
import { EllipsisOutlined, DownloadOutlined } from '@ant-design/icons';
import {getLessonplans} from '../actions/lessonplan';
import {getNotes} from '../actions/note';
import {getStudentreports} from '../actions/studentreport';
import { useLocation, useNavigate } from 'react-router-dom';

const Reports = (props) => {

    const  locs = useLocation();
    const nav = useNavigate();
    const { sessionid, termid, staffid, subjectid, claszid, studentid, subjectname, termname } = locs.state

    let {isLoading, lessonplans} = props.lessonplans
    let {isLoading:isLoadingNote, notes} = props.notes

    useEffect(() => {
            let params = {
            data:JSON.stringify(
            {
                    'sessionid':sessionid,
                    'termid':termid,
                    'subjectid':subjectid,
                    'claszid':claszid,
                    'studentid' : studentid,
                    'grp':1
                }),
                cat:'selected_lessonplan',
                table:'assets',
                narration:'get subjects'
            }
            props.getLessonplans(params)
          
    }, [])

    const openNote = (d) =>{  
         nav(`subject/${subjectid}/${d.id}`, 
            {state : {
              'note':d,
              "subjectname":subjectname,
              "termname":termname
            }}
            )
    }

    const getNotes = (id) =>{
        let params = {
            data:JSON.stringify(
            {
                    'themeid':id
                }),
                cat:'selected',
                table:'notes',
                narration:'get subjects'
            }
            props.getNotes(params)
    }
    

    const DropdownMenu = () => (
        <Dropdown key="more" >
          <Button>
            <EllipsisOutlined
              style={{
                fontSize: 20,
                verticalAlign: 'top',
              }} 
            /> Select Fees
          </Button>
        </Dropdown>
    );


    return (
        <div>
            <PageHeader
                title={subjectname}
                className="site-page-header no-print"
                subTitle={termname}
                tags={<Tag color="blue">Active</Tag>}
                extra={[
                    <DropdownMenu key="more" />,
                ]}
                avatar={{ src: 'https://avatars1.githubusercontent.com/u/8186664?s=460&v=4' }}    
            ></PageHeader>
           
    {
        lessonplans.map((prop, indx)=>{
            let {id, name, tname, weekid,  topic, tobjective, tcontent, tid} = prop
            return <div 
            style={{
                display:'flex',
                flexDirection:'column',
                flexWrap:'wrap',
                width:'100%',
                border:'solid 5px teal',
                margin:'10px',
                minHeight:"100px",
                backgroundColor:'#ffffff',
                textAlign:'left',
                padding:'5px'
            }}
            key={id}>
                <h3 style={{color:'teal', fontSize:'1.3rem'}}>{weekid} :<u> {topic} </u></h3>
                <h4 style={{color:'teal', fontSize:'1rem', overflow:'hidden'}}><b>{tname}</b></h4>
          
                <Row>
                <Col style={{minWidth:'200px'}} span={18}>
                    <p style={{fontSize:'1rem'}}>
                        <b>Content</b>
                    <div style={{whiteSpace:'pre-wraps'}}  dangerouslySetInnerHTML={{__html: tcontent}} />
                    </p>
                    <p style={{fontSize:'1rem'}}>
                    <b>Objective</b>
                    <div style={{whiteSpace:'pre-wraps'}}  dangerouslySetInnerHTML={{__html: tobjective}} />
                    </p>
                    <p style={{fontSize:'1rem'}}>
                        <Button isLoading={isLoadingNote} onClick={()=>getNotes(tid)} size="sm" style={{backgroundColor:'teal', color:'whitesmoke'}} icon={<DownloadOutlined />}>
                            LESSON NOTES / RESOURCES
                        </Button>
                    </p>
                </Col>
                <Col>
                <Space size={16} wrap>
    
                {
                    notes.filter(rw=>rw.themeid == tid).map(prop=>{
                        let {id, title} = prop
                        return  <Button 
                        key={id}
                        type="primary" 
                        icon={<DownloadOutlined />} 
                        size='lg' 
                        onClick={()=>openNote(prop)}
                        >
                            {title}
                        </Button>
                    })
                }
                </Space>
                </Col>
                </Row>
          
            </div>
        })
    }
            
        </div>
    )
}

const mapStateToProps = (state) => ({
    lessonplans:state.lessonplanReducer,
    notes:state.noteReducer,
    reports:state.reportReducer.reports,
    schools:state.reportReducer.schools,
    claszs:state.reportReducer.claszs,
    studentreport:state.studentreportReducer.studentreports,
    mid:state.userReducer.mid
})

const mapDispatchToProps = {
    getStudentreports,
    getLessonplans,
    getNotes
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports)
